/**
 * Hand-written helper for OpenAPI `format: "date"` query parameters (yyyy-MM-dd wire format).
 * Source of truth lives here in api-config/ (tracked in git).
 * Copied to api-client/apis/ by the generateApiClient script after generation.
 *
 * Uses local date arithmetic instead of toISOString() (which converts to UTC first),
 * so dates are never shifted by a day for users in UTC+ timezones.
 */

export function dateOnlyToQuery(date: Date): string {
  return [
    date.getFullYear(),
    String(date.getMonth() + 1).padStart(2, "0"),
    String(date.getDate()).padStart(2, "0"),
  ].join("-");
}
